/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getStructDecoder,
  getStructEncoder,
  getU8Decoder,
  getU8Encoder,
  type Codec,
  type Decoder,
  type Encoder,
} from "@solana/kit";

/** Resource constraints (placeholder - use RoleConstraints) */
export type ResourceConstraints = {
  /** Maximum resource usage */
  maxUsage: number;
};

export type ResourceConstraintsArgs = {
  /** Maximum resource usage */
  maxUsage: number;
};

export function getResourceConstraintsEncoder(): Encoder<ResourceConstraintsArgs> {
  return getStructEncoder([
    ["maxUsage", getU8Encoder()],
  ]);
}

export function getResourceConstraintsDecoder(): Decoder<ResourceConstraints> {
  return getStructDecoder([
    ["maxUsage", getU8Decoder()],
  ]);
}

export function getResourceConstraintsCodec(): Codec<ResourceConstraintsArgs, ResourceConstraints> {
  return combineCodec(getResourceConstraintsEncoder(), getResourceConstraintsDecoder());
}
